export default __webpack_public_path__ + "static/media/VU.fe6e47be.svg";